<template>
  <div id="app" class="App">
    <transition
        @enter="enter" @after-enter="afterEnter"
        @leave="leave" @after-leave="afterLeave"
        @before-enter="beforeEnter"
        :css="false" :mode="mode">>
        <router-view ref="page" v-if="loaded"/>
    </transition>
    <!-- <Navigation v-if="loaded"/> -->
  </div>
</template>

<script>

import Transition from '@/core/mixins/Transition'
// import Navigation from '@/components/game/navigation/Navigation'

export default {
  name: 'App',
  mixins: [ Transition ],
  // components: { Navigation },
  data: () => ({
    loaded: false
  }),
  mounted(){
    // this.loaded = true
    this.$nextTick(()=>{
      this.getLocation()
    })
  },

  methods: {
    getLocation() {
      this.$getLocation({})
          .then(coord => {
              this.$store.commit('app/SET_GEO', [ coord.lat, coord.lng ])
              this.loaded = true
          })
          .catch(error => this.loaded = true)
    },
  }


}
</script>

<style lang="stylus"> 

@import '~@/commons/fonts/Fonts'
@import '~@/commons/stylus/Global'





</style>

